import script from "./CollaboratorRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CollaboratorRegistroAsistencia.vue?vue&type=script&setup=true&lang=js"

import "./CollaboratorRegistroAsistencia.vue?vue&type=style&index=0&id=5eeede3e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eeede3e"]])

export default __exports__